import React from "react";
import HighchartsReact from "highcharts-react-official";
// import Highcharts from "./WrappedHighcharts";
import Highcharts from "highcharts";

import { getLineChartOptions } from "./utils";
import { defaultLabels } from "./constants";
import withTheme from "../../../hocs/withTheme";
import "highcharts/css/highcharts.css";
import "./LineChart.css";

function LineChart(props) {
    const {
        data = [],
        isCustomClassRequired = true,
        wrapperClassName = '',
        projection = false,
        legendEnabled = false,
        lineChartLegendOptions = undefined,
        lineChartTooltipOptions = undefined,
        goal = [],
        xMin = null,
        ySoftMin = undefined,
        dateFormat = {
            millisecond: "%H:%M:%S.%L",
            second: "%H:%M:%S",
            minute: "%H:%M",
            hour: "%H:%M",
            day: "%d-%m",
            week: "%d-%m",
            month: "%b %y",
            year: "%Y",
        },
        valueFormat = {
            symbol: "",
            precision: 2,
            thousand: ",",
            decimal: ".",
            format: "%s%v",
        },
        tooltipFormat = (num) => num,
        xAxisFormat = {
            millisecond: "%H:%M:%S.%L",
            second: "%H:%M:%S",
            minute: "%H:%M",
            hour: "%H:%M",
            day: "%d-%m",
            week: "%d-%m",
            month: "%b %y",
            year: "%Y",
        },
        yAxisFormat = null,
        height = 400,
        xTitle = undefined,
        yTitle = undefined,
        labels = defaultLabels,
        customXAxisFormat = null,
    } = props;

    Highcharts.setOptions({ lang: labels });

    return (
        <HighchartsReact
            containerProps={{
                className: isCustomClassRequired ? "LineChart" : (wrapperClassName || ""),
            }}
            highcharts={Highcharts}
            options={getLineChartOptions(
                data,
                dateFormat,
                valueFormat,
                goal,
                projection,
                tooltipFormat,
                xAxisFormat,
                yAxisFormat,
                height,
                xMin,
                ySoftMin,
                xTitle,
                yTitle,
                legendEnabled,
                lineChartLegendOptions,
                lineChartTooltipOptions,
                customXAxisFormat,
                isCustomClassRequired
            )}
        />
    );
}


export default withTheme(LineChart);
